// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResetAlarmRequest
 */
export interface ResetAlarmRequest {
    /**
     * Audit comment recorded with the reset (uses Reset2)
     */
    comment?: string;
}

/**
 * Check if a given object implements the ResetAlarmRequest interface.
 */
export function instanceOfResetAlarmRequest(value: object): value is ResetAlarmRequest {
    return true;
}

export function ResetAlarmRequestFromJSON(json: any): ResetAlarmRequest {
    return ResetAlarmRequestFromJSONTyped(json, false);
}

export function ResetAlarmRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResetAlarmRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}

export function ResetAlarmRequestToJSON(json: any): ResetAlarmRequest {
    return ResetAlarmRequestToJSONTyped(json, false);
}

export function ResetAlarmRequestToJSONTyped(value?: ResetAlarmRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'comment': value['comment'],
    };
}

